<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Hot Rodding in the San Fernando Valley</title>
<link href="template.css" rel="stylesheet" type="text/css"/>
<p class="title-head" id="Ack">A<span class="small">CKNOWLEDGMENTS</span></p>
<p class="para1">I’d like to thank the Road Kings of Burbank, and especially members Jim Miles, Tom Jandt, Tommy Ivo, Don Prudhomme, Butch Cederquist, Don Hoffman, Bob Muravez, Don Gaide, and Dick Plamondon, for contributing the images in this book and for their assistance and cooperation in putting the story together. Thanks also to Don Baldaseroni of the Burbank Historical Society, Bonneville historian Mark Lingua, and Jim Campbell for their help. Thanks to Desiree Gonzales for help with editorial matters and Dexter’s Camera of Ventura for image processing. And finally, a big thank-you to my old friend Harry Mishkin; Adam, Tiffanie, and Josh at The Grape House of Jazz and Spirits; Tina van Curan at Autobooks/Aerobooks of Burbank; and the hot rod community of Southern California for all the support and encouragement that they’ve given me over the years.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgments.vue?71a9ea11